/** Created by azhou on 2019/4/2.*/
<template>
  <div>
    <!-- <public-title v-show="isGroup">活跃明细<i class="el-icon-right"></i>{{ group_title }}
      <div slot="right" class="ml-auto">
        <span class="text-link ml-2 h6" @click="$router.back()">返回列表</span>
      </div>
    </public-title> -->
    <div :class="{'load-area': isGroup}">
      <ul class="list-head mt-4">
        <li class="w-50" v-for="item in userInfo.type==3?hotelTitleArr:titleArr" :key="item">{{item}}</li>
      </ul>
      <ul class="list-item" v-for="(item,index) in CreditList.lists" :key="index" :item="item">
        <li class="w-50 list-item-col breakword vule" @click="goForDetail(item)">{{item.oid}}</li>
        <li class="w-50 list-item-col" >{{item.add_time | formatTimestamp(1)}}</li>
        <!-- <li class="w-50 list-item-col" v-else>{{item.add_time}}</li> -->
        <li class="w-50 list-item-col" :class="[item.isadd ?'text-success':'text-danger']">
          {{!item.isadd ? '+':'-'}}{{userInfo.type==2 ? item.score :item.exp}}
        </li>
        <li class="w-50 list-item-col-end">{{item.type | formatVar('EXPTYPES')}}</li>
        <!-- <li class="w-50 list-item-col-end" v-else>{{item.type}}</li> -->
      </ul>
      <el-pagination background layout="prev, pager, next" class="mt-4"
        v-if="CreditList.total>0" :total="CreditList.total"
        :current-page="Number(queryCon.page)" @current-change="$GFUN.pageChange"/>
        <p v-if="CreditList.total<=0" class="mt-4">当前暂无数据</p>
    </div>
    
  </div>
</template>

<script>
  import { mapGetters,mapState,mapActions } from 'vuex'

  export default {
    name: 'itemCredit',
    computed: {
      ...mapState(['CreditList',]),
      ...mapGetters(['userInfo','storeInfo','isGroup']),
      queryCon() { return this.$route.query },
      group_title() { return sessionStorage.getItem('group_title') }
    },
    data() {
      return {
        titleArr:['订单号','时间','积分变动','类型'],
        hotelTitleArr:['订单号','时间','活跃变动','类型']
      }
    },
    watch:{
      queryCon() {  this.getLists();},
    },
    created() {
      this.getLists();
    },
    methods: {
      ...mapActions(['getStoreCredit']),
      /*跳转查看订单详情页*/
      goForDetail(cardItem) {
        let routeUrl = this.$router.resolve({
          name: 'OrderDetail',
          query: {
            orderType: 3,
            orderId: cardItem.oid,
            storeId: this.userInfo.type == 2 ? cardItem.main_id : (cardItem.store_id || cardItem.appoint),
            status: cardItem.status,
          }
        });
        window.open(routeUrl.href, '_blank');
      },
      async getLists() {
            let Id = this.storeInfo.storeId;
            if (this.queryCon.store) Id = this.queryCon.store;
            this.getStoreCredit({storeId:Id}); 
      }
    },
  }
</script>
<style scoped>
  .vule{
    cursor: pointer;
  }
</style>